module.exports = __webpack_public_path__ + "img/health-item1.54eba66c.png";